import React from 'react';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const FAQSection = () => {
  const header = useScrollAnimation({ threshold: 0.2 });
  const content = useScrollAnimation({ threshold: 0.1 });
  return (
    <section id="faq" data-testid="faq-section" className="py-16 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div ref={header.ref} className={`lg:col-span-4 scroll-slide-left ${header.isVisible?'scroll-visible':''}`}>
            <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">FAQ</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] mb-4" style={{fontFamily:"'Playfair Display',serif"}}>Frequently<br />Asked Questions.</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed">Direct answers regarding trademark registration, the filing process, and intellectual property protection.</p>
          </div>
          <div ref={content.ref} className={`lg:col-span-8 scroll-fade-up scroll-delay-2 ${content.isVisible?'scroll-visible':''}`}>
            <Accordion type="single" collapsible>
              {faqs.map(faq=>(
                <AccordionItem key={faq.id} value={`item-${faq.id}`} data-testid={`faq-item-${faq.id}`} className="border-b border-[#E2E2F0] border-t-0 border-l-0 border-r-0">
                  <AccordionTrigger className="text-left text-sm font-medium text-[#1E1B4B] hover:text-[#6366F1] py-5 [&[data-state=open]]:text-[#6366F1] transition-colors duration-300">{faq.question}</AccordionTrigger>
                  <AccordionContent className="text-sm font-normal text-[#4B5563] leading-relaxed pb-5">{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
export default FAQSection;
